import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { MDBContainer, MDBBtn, MDBBtnGroup, MDBIcon } from "mdb-react-ui-kit";

import { LoadingSpinner } from "Projects/CC_cubi_clan_project/GlobalComponents/LoadingSpinner/LoadingSpinner";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import AdminColorPalette from "../../Components/AdminColorPalette/AdminColorPalette";
import { NavMenu } from "Projects/CC_cubi_clan_project/GlobalComponents/NavMenu/NavMenu";
import { handleNavLinks } from "Projects/CC_cubi_clan_project/Utils/Utils";
import { getApp, getAppPermisions } from "Projects/CC_cubi_clan_project/Utils/PermissionManager";
import EditModeContainer from "Projects/CC_cubi_clan_project/GlobalComponents/EditModeContainer/EditModeContainer";
import IncidentLauncherButton from "Projects/CC_cubi_clan_project/GlobalComponents/IncidentLauncherButton/IncidentLauncherButton";

import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";

import AdnSection from "../../Components/AdnSection/AdnSection";
import AdminAdnSection from "../../Components/AdminAdnSection/AdminAdnSection";
import HistorySection from "../../Components/HistorySection/HistorySection";
import ContactSection from "../../Components/ContactSection/ContactSection";
import AdminContactSection from "../../Components/AdminContactSection/AdminContactSection";

import { CustomCarousel } from "../../Components/CustomCarousel/CustomCarousel";

import CarouselManager from "../../Components/CarouselManager/CarouselManager";
import NewsSection from "../../Components/NewsSection/NewsSection";
import NewsSectionManager from "../../Components/NewsSectionManager/NewsSectionManager";
import FooterManager from "../../Components/FooterManager/FooterManager";

import ProjectsSection from "../../Components/Projects/ProjectsSection/ProjectsSection";
import ProjectDetail from "../../Components/Projects/ProjectDetail/ProjectDetail";
import AdminProjectsSection from "../../Components/Projects/AdminProjectsSection/AdminProjectsSection";
import AdminProjectDetail from "../../Components/Projects/AdminProjectDetail/AdminProjectDetail";

import ActorsSection from "../../Components/Actors/ActorsSection/ActorsSection";
import ActorDetail from "../../Components/Actors/ActorDetail/ActorDetail";
import AdminActorSection from "../../Components/Actors/AdminActorSection/AdminActorSection";
import AdminActorDetail from "../../Components/Actors/AdminActorDetail/AdminActorDetail";

import NewsDetail from "../../Components/NewsDetail/NewsDetail";
import AdminNewsDetail from "../../Components/AdminNewsDetail/AdminNewsDetail";

import ProfilePage from "../../Components/ProfilePage/ProfilePage";
import ShowCalendar from "../../Components/ShowCalendar/ShowCalendar";

import TicketsSection from "../../Components/Tickets/TicketsSection/TicketsSection";

import Footer from "../../Components/Footer/Footer";

import logoImg from "images/logo_teansari.png";

import "./MainView.css";

export default function MainView() {
  const [cookies] = useCookies();
  const [isLoggedIn, setisLoggedIn] = useState();
  const location = useLocation();
  const [isLoading, setLoading] = useState(false);
  const [navActive, setNavActive] = useState("Home");
  const [isAdminView, setIsAdminView] = useState(false);
  const [appPermissions, setAppPermissions] = useState([]);
  const [calMediumOpen, setCalMediumOpen] = useState(false);
  const navigate = useNavigate();

  // Helper local: ¿el usuario tiene alguno de los permisos indicados?
  const hasAnyPermission = (names) => {
    if (!Array.isArray(names) || names.length === 0) return true;
    if (!Array.isArray(appPermissions) || appPermissions.length === 0) return false;
    return names.some((n) => appPermissions.some((p) => p && p.nombre === n));
  };

  // Cargar colores del tema guardados en BD y aplicarlos al DOM
  useEffect(() => {
    const THEME_CSS_VARS = {
      THEME_COLOR_PRIMARIO:  "--color-primario",
      THEME_COLOR_TEXTO:     "--color-texto",
      THEME_COLOR_ACENTO:    "--color-acento",
      THEME_COLOR_DESTACADO: "--color-destacado",
      THEME_COLOR_TARJETA:   "--color-tarjeta",
    };
    doFetch("TEAN", "getSiteContentByPrefix?prefix=THEME_COLOR", { method: "GET" })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data?.DATA)) {
          data.DATA.forEach(({ contentKey, contentValue }) => {
            const cssVar = THEME_CSS_VARS[contentKey];
            if (cssVar && contentValue) {
              document.documentElement.style.setProperty(cssVar, contentValue);
            }
          });
        }
      })
      .catch(() => { /* colores por defecto del CSS */ });
  }, []);

  useEffect(() => {
    const sessionId = cookies.SESSION_ID;
    // Checking if user is not loggedIn
    if (!sessionId) {
      setisLoggedIn(false);
    } else {
      setisLoggedIn(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookies]);

  useEffect(() => {
    // Checking if user is not loggedIn
    if (isLoggedIn) {
      //navigate("/admin");
      // Cargar permisos del usuario sobre la app TEAN para gobernar
      // visibilidad de entradas de navmenu sensibles (ej. Entradas).
      (async () => {
        try {
          const app = await getApp("TEAN", () => {});
          if (app) {
            const perms = await getAppPermisions(app, () => {});
            setAppPermissions(Array.isArray(perms) ? perms : []);
          }
        } catch (e) {
          console.error("Error cargando permisos TEAN:", e);
        }
      })();
    } else {
      setAppPermissions([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  const navMenuDefault = [
    {
      devName: "Home",
      label: "Inicio",
      active: location.pathname === "/",
      visible: true,
      disabled: false,
      url: "/",
    },
    {
      devName: "ADN",
      label: "ADN Teansari",
      active: location.pathname === "/adn",
      visible: true,
      disabled: false,
      url: "/adn",
    },
    {
      devName: "About",
      label: "Quiénes somos",
      active: location.pathname === "/about",
      visible: true,
      disabled: false,
      url: "/about",
    },
    {
      devName: "Projects",
      label: "Obras",
      active: location.pathname.includes("project"),
      visible: true,
      disabled: false,
      url: "/projects",
    },
    {
      devName: "History",
      label: "Y antes qué",
      active: location.pathname === "/history",
      visible: false,
      disabled: false,
      url: "/history",
    },
    {
      devName: "Contact",
      label: "Contáctanos",
      active: location.pathname === "/contact",
      visible: true,
      disabled: false,
      url: "/contact",
    },
    {
      devName: "Tickets",
      label: "Entradas",
      active: location.pathname.startsWith("/tickets"),
      visible: hasAnyPermission(["APP_ADMIN", "TICKET_MANAGE", "TICKET_SELL"]),
      disabled: false,
      url: "/tickets",
    },
  ];
  // Mantenemos navMenu como state por compatibilidad con la API previa,
  // pero NavMenu recibirá directamente navMenuDefault + key reactiva a
  // permisos para que la entrada "Entradas" aparezca tras hacer login.
  // eslint-disable-next-line no-unused-vars
  const [navMenu, setNavMenu] = useState(navMenuDefault);

  const onHandleNavLinks = (event, url) => {
    if (event?.target?.name === "UserDetail") {
      navigate("/profile");
      return;
    }
    handleNavLinks(event, url, navigate, setNavActive);
  };

  const onLoadingSafe = (value) => {
    // Only explicit true keeps the overlay active; anything else disables it.
    setLoading(value === true);
  };

  const onUserLoggedIn = (inputLoggedIn) => {
    setisLoggedIn(inputLoggedIn);
    if (!inputLoggedIn) {
      setIsAdminView(false);
    }
    if (inputLoggedIn) {
      toast.show({
        message: "Usuario logueado correctamente",
        type: "success",
        position: "bottom-center",
        size: "wide",
        animation: "slide",
        timeout: 3000, // o 0 si quieres sólo manual
      });
    } else {
      toast.show({
        message: "Sesión de usuario cerrada",
        type: "info",
        position: "bottom-center",
        size: "wide",
        animation: "slide",
        timeout: 3000, // o 0 si quieres sólo manual
      });
    }
  };

  return (
    <div>
      <LoadingSpinner isLoading={isLoading} />
      <IncidentLauncherButton
        appCode="TEAN"
        visible={!!isLoggedIn}
        label="Abrir incidencia"
        iconOnly
        floatingClassName="inci-launcher-sidebar"
      />
      <NavMenu
        key={`tean-nav-${appPermissions.length}`}
        title="TEANSARI"
        appCode="TEAN"
        logoImg={logoImg}
        navMenu={navMenuDefault}
        onHandleNavLinks={onHandleNavLinks}
        onLoading={onLoadingSafe}
        onNavigate={navigate}
        onLoggedIn={onUserLoggedIn}
      ></NavMenu>
      <MDBContainer className="my-4">
        {/* Paleta de colores — solo en modo admin */}
        {isLoggedIn && isAdminView && <AdminColorPalette />}

        {/* Global admin toggle — floating (solo ADMIN / MANAGER) */}
        {isLoggedIn && hasAnyPermission(["APP_ADMIN", "APP_MANAGE"]) && (
          <div className="admin-toggle-floating">
            <MDBBtnGroup>
              <MDBBtn
                color={!isAdminView ? "primary" : "light"}
                size="sm"
                onClick={() => setIsAdminView(false)}
              >
                <MDBIcon fas icon="eye" className="me-1" />
                Vista pública
              </MDBBtn>
              <MDBBtn
                color={isAdminView ? "primary" : "light"}
                size="sm"
                onClick={() => setIsAdminView(true)}
              >
                <MDBIcon fas icon="pen" className="me-1" />
                Vista admin
              </MDBBtn>
            </MDBBtnGroup>
          </div>
        )}
        {location.pathname === "/" && (
          <>
            <EditModeContainer
              value={isLoggedIn ? "admin" : "public"}
              viewKey={isLoggedIn && isAdminView ? "CarouselManager" : "CustomCarousel"}
              registry={{
                CustomCarousel,
                CarouselManager,
              }}
              variants={[
                {
                  name: "public",
                  defaultKey: "CustomCarousel",
                  allowed: ["CustomCarousel"],
                },
                {
                  name: "admin",
                  defaultKey: "CustomCarousel",
                  allowed: ["CustomCarousel", "CarouselManager"],
                },
              ]}
              componentProps={{
                CustomCarousel: {
                  showControls: true,
                  showIndicators: true,
                  filterActive: true,
                  className: "mb-5",
                },
                CarouselManager: {
                  onLoading: onLoadingSafe,
                },
              }}
              showControls={false}
            />
            {!(isLoggedIn && isAdminView) && (
              <div className="main-cal-zone mb-3">
                {/* Mobile (<768px) + Large (≥1400px): ShowCalendar maneja sus propias secciones */}
                <ShowCalendar />
                {/* Medium (768–1399px): botón toggle → panel lado a lado */}
                <div className="main-cal-medium">
                  <button
                    className="main-cal-medium-toggle"
                    onClick={() => setCalMediumOpen((o) => !o)}
                  >
                    <MDBIcon fas icon="calendar-alt" className="me-2" />
                    {calMediumOpen ? "Ocultar calendario" : "Ver calendario de obras"}
                    <MDBIcon fas icon={calMediumOpen ? "chevron-up" : "chevron-down"} className="ms-2" />
                  </button>
                  {calMediumOpen && (
                    <div className="main-cal-medium-panel">
                      <ShowCalendar fixedMode="calendar" />
                      <ShowCalendar fixedMode="list" />
                    </div>
                  )}
                </div>
              </div>
            )}
            <EditModeContainer
              value={isLoggedIn ? "admin" : "public"}
              viewKey={isLoggedIn && isAdminView ? "NewsSectionManager" : "NewsSection"}
              registry={{
                NewsSection,
                NewsSectionManager,
              }}
              variants={[
                {
                  name: "public",
                  defaultKey: "NewsSection",
                  allowed: ["NewsSection"],
                },
                {
                  name: "admin",
                  defaultKey: "NewsSection",
                  allowed: ["NewsSection", "NewsSectionManager"],
                },
              ]}
              componentProps={{
                NewsSection: {
                  onLoading: onLoadingSafe,
                  onHandleNavLinks: onHandleNavLinks,
                },
                NewsSectionManager: {
                  onLoading: onLoadingSafe,
                  onHandleNavLinks: onHandleNavLinks,
                },
              }}
              showControls={false}
            />
          </>
        )}
        {location.pathname === "/adn" && (
          <EditModeContainer
            value={isLoggedIn ? "admin" : "public"}
            viewKey={isLoggedIn && isAdminView ? "AdminAdnSection" : "AdnSection"}
            registry={{
              AdnSection,
              AdminAdnSection,
            }}
            variants={[
              {
                name: "public",
                defaultKey: "AdnSection",
                allowed: ["AdnSection"],
              },
              {
                name: "admin",
                defaultKey: "AdnSection",
                allowed: ["AdnSection", "AdminAdnSection"],
              },
            ]}
            componentProps={{
              AdnSection: {
                onLoading: onLoadingSafe,
              },
              AdminAdnSection: {
                onLoading: onLoadingSafe,
              },
            }}
            showControls={false}
          />
        )}
        {location.pathname === "/about" && (
          <EditModeContainer
            value={isLoggedIn ? "admin" : "public"}
            viewKey={isLoggedIn && isAdminView ? "AdminActorSection" : "ActorsSection"}
            registry={{
              ActorsSection,
              AdminActorSection,
            }}
            variants={[
              {
                name: "public",
                defaultKey: "ActorsSection",
                allowed: ["ActorsSection"],
              },
              {
                name: "admin",
                defaultKey: "ActorsSection",
                allowed: ["ActorsSection", "AdminActorSection"],
              },
            ]}
            componentProps={{
              ActorsSection: {
                onLoading: onLoadingSafe,
                onHandleNavLinks: onHandleNavLinks,
              },
              AdminActorSection: {
                onLoading: onLoadingSafe,
                onHandleNavLinks: onHandleNavLinks,
              },
            }}
            showControls={false}
          />
        )}
        {location.pathname.includes("/actor/") && (
          <EditModeContainer
            value={isLoggedIn ? "admin" : "public"}
            viewKey={isLoggedIn && isAdminView ? "AdminActorDetail" : "ActorDetail"}
            registry={{
              ActorDetail,
              AdminActorDetail,
            }}
            variants={[
              {
                name: "public",
                defaultKey: "ActorDetail",
                allowed: ["ActorDetail"],
              },
              {
                name: "admin",
                defaultKey: "ActorDetail",
                allowed: ["ActorDetail", "AdminActorDetail"],
              },
            ]}
            componentProps={{
              ActorDetail: {
                onLoading: onLoadingSafe,
                onHandleNavLinks: onHandleNavLinks,
              },
              AdminActorDetail: {
                onLoading: onLoadingSafe,
                onHandleNavLinks: onHandleNavLinks,
              },
            }}
            showControls={false}
          />
        )}
        {location.pathname === "/projects" && (
          <EditModeContainer
            value={isLoggedIn ? "admin" : "public"}
            viewKey={isLoggedIn && isAdminView ? "AdminProjectsSection" : "ProjectsSection"}
            registry={{
              ProjectsSection,
              AdminProjectsSection,
            }}
            variants={[
              {
                name: "public",
                defaultKey: "ProjectsSection",
                allowed: ["ProjectsSection"],
              },
              {
                name: "admin",
                defaultKey: "ProjectsSection",
                allowed: ["ProjectsSection", "AdminProjectsSection"],
              },
            ]}
            componentProps={{
              ProjectsSection: {
                onLoading: onLoadingSafe,
                onHandleNavLinks: onHandleNavLinks,
              },
              AdminProjectsSection: {
                onLoading: onLoadingSafe,
                onHandleNavLinks: onHandleNavLinks,
              },
            }}
            showControls={false}
          />
        )}
        {location.pathname.includes("/project/") && (
          <EditModeContainer
            value={isLoggedIn ? "admin" : "public"}
            viewKey={isLoggedIn && isAdminView ? "AdminProjectDetail" : "ProjectDetail"}
            registry={{
              ProjectDetail,
              AdminProjectDetail,
            }}
            variants={[
              {
                name: "public",
                defaultKey: "ProjectDetail",
                allowed: ["ProjectDetail"],
              },
              {
                name: "admin",
                defaultKey: "ProjectDetail",
                allowed: ["ProjectDetail", "AdminProjectDetail"],
              },
            ]}
            componentProps={{
              ProjectDetail: {
                onLoading: onLoadingSafe,
                onHandleNavLinks: onHandleNavLinks,
              },
              AdminProjectDetail: {
                onLoading: onLoadingSafe,
                onHandleNavLinks: onHandleNavLinks,
              },
            }}
            showControls={false}
          />
        )}
        {location.pathname.includes("/noticia/") && (
          <EditModeContainer
            value={isLoggedIn ? "admin" : "public"}
            viewKey={isLoggedIn && isAdminView ? "AdminNewsDetail" : "NewsDetail"}
            registry={{
              NewsDetail,
              AdminNewsDetail,
            }}
            variants={[
              {
                name: "public",
                defaultKey: "NewsDetail",
                allowed: ["NewsDetail"],
              },
              {
                name: "admin",
                defaultKey: "NewsDetail",
                allowed: ["NewsDetail", "AdminNewsDetail"],
              },
            ]}
            componentProps={{
              NewsDetail: {
                onLoading: onLoadingSafe,
                onHandleNavLinks: onHandleNavLinks,
              },
              AdminNewsDetail: {
                onLoading: onLoadingSafe,
                onHandleNavLinks: onHandleNavLinks,
              },
            }}
            showControls={false}
          />
        )}
        {location.pathname === "/history" && <HistorySection />}
        {location.pathname === "/contact" && (
          <EditModeContainer
            value={isLoggedIn ? "admin" : "public"}
            viewKey={isLoggedIn && isAdminView ? "AdminContactSection" : "ContactSection"}
            registry={{
              ContactSection,
              AdminContactSection,
            }}
            variants={[
              {
                name: "public",
                defaultKey: "ContactSection",
                allowed: ["ContactSection"],
              },
              {
                name: "admin",
                defaultKey: "ContactSection",
                allowed: ["ContactSection", "AdminContactSection"],
              },
            ]}
            componentProps={{
              ContactSection: {
                onLoading: onLoadingSafe,
              },
              AdminContactSection: {
                onLoading: onLoadingSafe,
              },
            }}
            showControls={false}
          />
        )}
        {location.pathname === "/profile" && isLoggedIn && (
          <ProfilePage onLoading={onLoadingSafe} />
        )}

        {location.pathname === "/tickets" &&
          isLoggedIn &&
          hasAnyPermission(["APP_ADMIN", "TICKET_MANAGE", "TICKET_SELL"]) && (
            <TicketsSection onLoading={onLoadingSafe} />
          )}

      </MDBContainer>
      {/* Footer: inline editable in admin mode */}
      {isLoggedIn && isAdminView ? (
        <FooterManager onLoading={onLoadingSafe} />
      ) : (
        <Footer showIncidentBtn={!!isLoggedIn} appCode="TEAN" />
      )}
    </div>
  );
}
